'use strict';

intellidealerAppCoreModule.factory('localeResource', function ($resource, appConfigurationService) {
  return {
    localeData: $resource(appConfigurationService.basePath + '/rest/locale/localeData'),
    publicLocaleData: $resource(appConfigurationService.basePath + '/rest/locale/publicLocaleData')
  }
});
